import React from 'react';

const OwnerPage = () => {
  return <div>Owner Page (Kosong)</div>;
};

export default OwnerPage;